/**
 * Opt-in two-phase panel mounting, selected by `?panelLoadMethod=deferred`.
 *
 * Default (`immediate`): React mounts the mosaic/grid outline and every panel
 * body in one commit — fastest to FULLY painted content.
 *
 * `deferred`: the outline (panes, splits, sizes, headers, tab strips) renders
 * first with blank bodies, and the panels mount on a later frame. Measured
 * trade-off: structure appears noticeably sooner, but total time to painted
 * content is ~60% longer because the subtree reconciles twice. Kept behind a
 * flag so it can be judged by feel on a deployed stage without making anyone
 * pay for it by default.
 */
export type PanelLoadMethod = 'immediate' | 'deferred'

export function parsePanelLoadMethod(search: string): PanelLoadMethod {
  return new URLSearchParams(search).get('panelLoadMethod') === 'deferred'
    ? 'deferred'
    : 'immediate'
}

/** Read once at module load: the flag is a page-level choice, not reactive. */
export const PANEL_LOAD_METHOD: PanelLoadMethod =
  typeof window === 'undefined' ? 'immediate' : parsePanelLoadMethod(window.location.search)

export const DEFER_PANEL_MOUNT = PANEL_LOAD_METHOD === 'deferred'
